import { PencilSimple, Trash, ArrowRight, User } from "@phosphor-icons/react";
import { fmtInt } from "@/lib/api";

/**
 * Card mobile de cliente — usado em telas < md.
 * Layout empilhado com todas as informações da linha da tabela,
 * botões grandes para toque no dedo.
 */
export default function CustomerCardMobile({ customer, onOpen, onEdit, onDelete }) {
  const c = customer;
  return (
    <div
      className="border-2 border-zinc-200 bg-white p-4"
      data-testid={`customer-card-${c.id}`}
    >
      {/* Cabeçalho: nome + qtd pedidos */}
      <div className="flex items-start justify-between gap-3 mb-3">
        <button
          type="button"
          onClick={() => onOpen(c.id)}
          className="flex-1 min-w-0 text-left"
          data-testid={`card-cust-open-${c.id}`}
        >
          <div className="flex items-center gap-2">
            <User size={14} weight="bold" className="text-zinc-400 shrink-0" />
            <span className="font-bold text-sm leading-tight truncate">
              {c.name}
            </span>
          </div>
        </button>
        <div className="shrink-0 text-right">
          <div className="font-mono font-black text-lg leading-none">
            {fmtInt(c.orders_count || 0)}
          </div>
          <div className="overline text-[10px] text-zinc-400">pedidos</div>
        </div>
      </div>

      {/* Grid de dados */}
      <div className="grid grid-cols-2 gap-3 mb-3">
        <div>
          <div className="overline text-[10px] text-zinc-400 mb-0.5">DOCUMENTO</div>
          <div className="font-mono text-xs truncate">{c.document || "—"}</div>
        </div>
        <div>
          <div className="overline text-[10px] text-zinc-400 mb-0.5">CIDADE/UF</div>
          <div className="text-xs text-zinc-700 truncate">
            {c.city ? `${c.city}/${c.state || ""}` : "—"}
          </div>
        </div>
        <div className="col-span-2">
          <div className="overline text-[10px] text-zinc-400 mb-0.5">EMAIL</div>
          <div className="text-xs text-zinc-700 truncate">{c.email || "—"}</div>
        </div>
        <div className="col-span-2">
          <div className="overline text-[10px] text-zinc-400 mb-0.5">TELEFONE</div>
          <div className="font-mono text-xs">
            {c.cellphone || c.phone || "—"}
          </div>
        </div>
      </div>

      {/* Ações */}
      <div className="flex items-center gap-2 pt-3 border-t border-zinc-200">
        <button
          type="button"
          className="btn btn-ghost btn-tight flex-1"
          onClick={() => onOpen(c.id)}
          data-testid={`card-cust-view-${c.id}`}
        >
          <span>Ver</span>
          <ArrowRight size={12} weight="bold" />
        </button>
        <button
          type="button"
          className="btn btn-ghost btn-tight"
          onClick={() => onEdit(c)}
          data-testid={`card-cust-edit-${c.id}`}
          aria-label={`Editar ${c.name}`}
        >
          <PencilSimple size={14} weight="bold" />
        </button>
        <button
          type="button"
          className="btn btn-ghost btn-tight text-red-600"
          onClick={() => onDelete(c.id)}
          data-testid={`card-cust-delete-${c.id}`}
          aria-label={`Excluir ${c.name}`}
        >
          <Trash size={14} weight="bold" />
        </button>
      </div>
    </div>
  );
}
